
// Namespacing

window.Deckperfo = window.Deckperfo  || {};


// BlocTemoignages1 Module

(function ($) {

    "use strict";

    var self;

    // ------------------------------------
    // CONSTRUCTOR
    // ------------------------------------

    function BlocTemoignages1() {

        self = this;

    }

    // ------------------------------------
    // INIT
    // ------------------------------------

    BlocTemoignages1.prototype.init = function () {

        var elem = document.querySelector('.temoignages-carousel');

        if( elem ){

            var flkty = new Flickity( elem, {
                'cellAlign': 'left',
                'contain': true,
                'wrapAround': true,
                'prevNextButtons': false,
                'imagesLoaded': true
            });

        }

    };

    this.BlocTemoignages1 = new BlocTemoignages1();

}.bind(Deckperfo, jQuery)());